import React from 'react';
import {Grid, Typography, makeStyles} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import FixedNavigation from './common/FixedNavigation';

interface BookAppointmentProps {
    onExit: () => void;
    onNext: () => void;
}
const useStyles = makeStyles(() => ({
    wrapper: {
        padding: '20px',
    },
    title: {
        fontFamily: 'LoraRegular',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '44px',
        lineHeight: '48.4px',
        color: '#456d69',
        marginBottom: '28px',
    },
    p1: {
        fontFamily: 'FredokaLight',
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '28.8px',
        color: '#434343',
    },
    navigation: {
        marginTop: '20px',
    },
    backBtn: {
        borderRadius: '20px',
    },
    nextBtn: {
        minWidth: '400px',
        borderRadius: '20px',
    },
}));

const BookAppointment: React.FC<BookAppointmentProps> = observer(({onNext, onExit}) => {
    const classes = useStyles();
    return (
        <Grid container classes={{root: classes.wrapper}}>
            <Typography classes={{root: classes.title}} data-testid="bookAppointment">
                Book a Time on your Calendar with the Client.
            </Typography>
            <Grid container>
                <Grid item xs={12}>
                    <Typography className={classes.p1}>
                        Find a time that works for you and your client, then please let them know that you will have the
                        decision result by then and can share if they qualified for the product along with final
                        numbers.
                    </Typography>
                </Grid>
            </Grid>
            <FixedNavigation onNext={onNext} isLoading={false} />
        </Grid>
    );
});

export default BookAppointment;
